export default __webpack_public_path__ + "static/media/danta_black_female.90f152a8.png";